import { render, staticRenderFns } from "./YanXiuBaoMing.vue?vue&type=template&id=3d45358e&scoped=true&"
import script from "./YanXiuBaoMing.vue?vue&type=script&lang=js&"
export * from "./YanXiuBaoMing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45358e",
  null
  
)

export default component.exports